import React from 'react';
import { Modal } from 'src/components';
import ButtonGroup, { LayoutType } from 'src/components/button-group/button-group';
import { ButtonParamType, DefaultButtonStyle } from 'src/components/button/button';
import './credit-vetting-incomplete-modal.scss';

export default function CreditVettingDetailsModal(props) {
  const getConfirmButton = (handleClick) => {
    return {
      automationId: 'Onboarding_Choose_Solution_CV_Missing_Details_Confirm',
      buttonParams: {
        type: ButtonParamType.NormalButton,
        onClick: handleClick,
      },
      label: 'Thanks, continue',
      buttonStyle: DefaultButtonStyle()
        .hasPrimaryAction()
        .isMediumSize()
        .hasLightMode()
        .build(),
      className: 'modal-button',
    };
  };

  return (
    <Modal
      modalStyle="CreditVettingDetailsModal"
      show={props.show}
      cardStyle="submit-modal-card"
      header={() => (
        <p className="modal-head heading-four has-text-centered">We need a few more details</p>
      )}
      headerStyle="submit-modal-card-head"
      body={() => (
        <p className="modal-body-text">
          You’ve added a new product to your cart that requires credit vetting for us to setup your
          debit order.
        </p>
      )}
      bodyStyle="submit-modal-card-body has-text-centered"
      footer={() => (
        <ButtonGroup
          buttons={[getConfirmButton(props.onButtonClick)]}
          layoutType={LayoutType.CENTERED}
        />
      )}
      footerStyle="submit-modal-card-foot"
      backdropStyle="backdrop"
    />
  );
}
